import { render, staticRenderFns } from "./RejectButton.vue?vue&type=template&id=2fa58960&scoped=true&"
import script from "./RejectButton.vue?vue&type=script&lang=js&"
export * from "./RejectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa58960",
  null
  
)

export default component.exports